import React, { useState, useEffect } from "react"
import { makeStyles } from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'
import Fab from '@material-ui/core/Fab'
import PDFIcon from '@material-ui/icons/PictureAsPdf'
import { useLazyQuery } from '@apollo/react-hooks'
import { documentQueries } from '../graphql/queries'
import CircularProgress from '@material-ui/core/CircularProgress'
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Button } from "@material-ui/core"


const useStyles = makeStyles(() => ({
  fab: {
    position: 'fixed',
    bottom: 170,
    '& > span > svg': {
      fontSize: 32,
    },
    '@media (max-width: 1050px)': {
      bottom: '75px',
      right: '20px'
    }
  },
  downloadButton: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    padding: '10px',
    margin: '0 10px',
    borderRadius: '8px',
    color: '#FFF',
    backgroundColor: '#4212E3'
  },
  loadingDiv: {
    padding: 50,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
}))

const PDFButton = ({ resultId = '', finalAnswers = [], content = '' }) => {
  const classes = useStyles()
  const [modal, setModal] = useState(false)
  const [pdfRef, setPdfRef] = useState('')
  const [pdfType, setPdfType] = useState('normal')

  const backFinalAnswers = finalAnswers.map(answ => {
    if (answ) {
      return {
        certa: answ.certa,
        comentario: answ.comentario,
        selectedAnswer: answ.selectedAnswer
      }
    } else {
      return {
        certa: false,
        comentario: '',
        selectedAnswer: ''
      }
    } 
  })

  const [loadPdf, { loading, data }] = useLazyQuery(documentQueries.GET_DOC, {
    variables: { resultId, finalAnswers: backFinalAnswers, quizContent: content, pdfType }
  })

  const handleModal = () => {
    setModal(!modal);
  }

  const handlePdfType = (type) => {
    setPdfType(type)
    loadPdf()    
  }

  useEffect(() => {
    setPdfRef(`data:application/pdf;base64,${data?.documentPdf}`)
  }, [data])

  useEffect(() => {
    if(pdfRef.length > 50) {
      let linkButton = document.createElement('a')
      linkButton.style.display = 'none'
      linkButton.href = pdfRef
      linkButton.setAttribute('download','resultado.pdf')

      if (typeof linkButton.download === 'undefined') {
        linkButton.setAttribute('target', '_blank');
      }
      document.body.appendChild(linkButton);
      linkButton.click();

      setTimeout(function() {
        document.body.removeChild(linkButton);
        window.URL.revokeObjectURL(pdfRef);
        handleModal()
    }, 200)
    }
  }, [pdfRef]) //eslint-disable-line

  const pdfTypes = [
    {
      id: Math.random(),
      name: 'Perguntas sequências',
      type: 'normal'
    },
    {
      id: Math.random(),
      name: 'Uma pergunta por página',
      type: 'onePerPage'
    },
    {
      id: Math.random(),
      name: 'Apenas visualização',
      type: 'allInOne'
    }
  ]

  return (
    <>
      <Button onClick={handleModal} className={classes.fab}>
        <Fab color="primary" aria-label="add">
          <PDFIcon/>
        </Fab>
      </Button>
      <Dialog onClose={handleModal} aria-labelledby="simple-dialog-title" open={modal}>
        <DialogTitle id="simple-dialog-title">Escolha o tipo de PDF</DialogTitle>
        {(loading) ? (
          <div className={classes.loadingDiv}>
            <CircularProgress color={'white'} size={24}  />
          </div>
        ) : (
          <List>
            {pdfTypes.map(type => (
              <ListItem button onClick={() => handlePdfType(type.type)} key={type.id}>
                <ListItemAvatar>
                <PDFIcon/>
                </ListItemAvatar>
                <ListItemText primary={type.name} />
              </ListItem>
            ))}
          </List>
        )}
      </Dialog>
    </>
  )
}
export default PDFButton;